<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Manage Incomes{{ (month ? ' for ' + monthName(month) : '') + ' ' + (year ? ' ' + year : '') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-4">
            <v-container fluid grid-list-xs class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-container fluid grid-list-lg>
                    <v-form ref="frmLoadIncomes" v-model="frmLoadIncomesValid" v-on:submit.prevent>
                      <v-layout row wrap>
                        <v-flex xs4 sm3 offset-sm2>
                          <v-select
                            v-model="cboMonth"
                            :items="months"
                            item-text="name"
                            item-value="value"
                            label="Month"
                            :rules="[v => !!v || 'Month is required']"
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex xs4 sm3>
                          <v-select
                            v-model="cboYear"
                            :items="years"
                            label="Year"
                            :rules="[v => !!v || 'Year is required']"
                            required
                          ></v-select>
                        </v-flex>
                        <v-flex xs4 sm1>
                          <v-btn
                            outline
                            small
                            :disabled="!frmLoadIncomesValid"
                            @click="$router.push('/incomes/' + cboYear + '/' + cboMonth)"
                          >
                            Load
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-flex>
                <v-flex xs12 v-if="(year >= 2000 && year <= 3000) && (month >= 1 && month <= 12)">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 v-if="(year >= 2000 && year <= 3000) && (month >= 1 && month <= 12)" class="pt-5">
                  <v-card flat class="pt-0" v-if="incomes.length > 0">
                    <v-container fluid grid-list-xs class="pt-0">
                      <v-layout row wrap>
                        <v-flex
                          xs12
                          text-xs-center
                          layout
                          align-center
                          justify-center
                          class="mt-0"
                        >
                          <table
                            class="pt-0 mt-0"
                            style="width: 100%;"
                          >
                            <tr v-for="(branch, branchIndex) in incomes" :key="branchIndex">
                              <td class="text-xs-left title font-weight-regular">
                                <strong>{{ branch.branchName }}</strong>
                                <table border=0 width="100%" class="ml-3 mt-2" cellpadding=0 cellspacing=0>
                                  <tr v-for="(income, incomeIndex) in branch.incomes" :key="income.incomeId">
                                    <td width="60%" class="body-2 font-weight-regular">
                                      <div>
                                        {{ income.name }}
                                        <v-btn
                                          small
                                          outline
                                          class="ml-2"
                                          v-if="income.remarks.length > 0"
                                          @click="showRemarks(income)"
                                        >
                                          Remarks
                                        </v-btn>
                                        <v-btn
                                          small
                                          icon
                                          class="mr-0 grey--text text--darken-1"
                                          v-if="accessDeleteIncome"
                                          @click="showDeleteIncomeDialog(income)"
                                        >
                                          <v-icon small>delete</v-icon>
                                        </v-btn>
                                        <v-btn
                                          small
                                          icon
                                          class="ml-0 grey--text text--darken-1"
                                          v-if="accessUpdateIncome"
                                          @click="showEditIncomeDialog(income)"
                                        >
                                          <v-icon small>edit</v-icon>
                                        </v-btn>
                                      </div>
                                      <div class="caption grey--text text--darken-1">
                                        <span v-if="income.updatedByAdminName.length > 0">Updated by {{ income.updatedByAdminName }} on {{ income.updatedDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                                        <span v-else-if="income.createdByAdminName.length > 0">Added by {{ income.createdByAdminName }} on {{ income.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                                      </div>
                                    </td>
                                    <td width="30%" class="body-2 font-weight-regular" :style="(incomeIndex >= (branch.incomes.length - 1) ? 'border-bottom:1px solid #ffffff;' : '')">
                                      {{ def.currency.sign + formatPrice(income.amountInBase, def.currency.decimals, def.currency.decimalSign) }}
                                      <span v-if="income.currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text ml-3">({{ income.currencySign }}{{ formatPrice(income.amount, income.currencyDecimals, income.currencyDecimalSign) }})</span>
                                    </td>
                                    <td width="10%" class="title font-weight-regular">
                                      <span v-if="incomeIndex >= (branch.incomes.length - 1)">+</span>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td class="text-xs-right subheading font-weight-bold" valign="bottom">
                                {{ def.currency.sign + formatPrice(branch.totalAmountInBase, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="text-xs-left title font-weight-regular">
                                <strong>Total</strong>
                              </td>
                              <td class="text-xs-right title font-weight-bold" valign="bottom">
                                {{ def.currency.sign + formatPrice(totalIncomesInBase, def.currency.decimals, def.currency.decimalSign) }}
                              </td>
                            </tr>
                          </table>
                        </v-flex>
                        <v-flex
                          xs12
                          layout
                          text-xs-left
                          class="mt-5"
                          v-if="accessCreateIncome"
                        >
                          <v-btn
                            small
                            outline
                            @click="showAddIncomeDialog"
                          >
                            Add Income
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>

          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog
        v-model="addIncomeDialog"
        max-width="800"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">Add Incomes</h3>
          <v-form ref="frmAddIncome" v-model="frmAddIncomeValid">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Name"
                    v-model="txtIncomeName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="cboIncomeBranchId"
                    v-bind:items="branches"
                    label="Branch"
                    item-text="name"
                    item-value="branchId"
                  ></v-select>
                </v-flex>
                <v-flex xs3>
                  <v-select
                    v-model="cboIncomeCurrencyCode"
                    v-bind:items="currencies"
                    label="Currency"
                    item-text="sign"
                    item-value="currencyCode"
                    :rules="[v => !!v || 'Currency is required']"
                    required
                    @change="txtIncomeExchangeRateToBase = getRateToBase(cboIncomeCurrencyCode)"
                  ></v-select>
                </v-flex>
                <v-flex xs9>
                  <v-text-field
                    label="Amount"
                    v-model="txtIncomeAmount"
                    :rules="[v => !!v || 'Amount is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="cboIncomeCurrencyCode.length > 0 && cboIncomeCurrencyCode !== def.currency.currencyCode">
                  <v-text-field
                    label="Rate to USD"
                    v-model="txtIncomeExchangeRateToBase"
                    :rules="[v => !!v || 'Rate to USD is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <trumbowyg id="trumbowyg" v-model="txtIncomeRemarks" :config="trumbowygConfig"></trumbowyg>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    block
                    large
                    color="primary"
                    :disabled="!frmAddIncomeValid"
                    @click="addIncome"
                  >
                    Add
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="editIncomeDialog"
        max-width="800"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">Edit Incomes</h3>
          <v-form ref="frmEditIncome" v-model="frmEditIncomeValid">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Name"
                    v-model="txtIncomeName"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="cboIncomeBranchId"
                    v-bind:items="branches"
                    label="Branch"
                    item-text="name"
                    item-value="branchId"
                  ></v-select>
                </v-flex>
                <v-flex xs5>
                  <v-select
                    v-model="cboIncomeCurrencyCode"
                    v-bind:items="currencies"
                    label="Currency"
                    item-text="sign"
                    item-value="currencyCode"
                    :rules="[v => !!v || 'Currency is required']"
                    required
                    @change="txtIncomeExchangeRateToBase = getRateToBase(cboIncomeCurrencyCode)"
                  ></v-select>
                </v-flex>
                <v-flex xs7>
                  <v-text-field
                    label="Amount"
                    v-model="txtIncomeAmount"
                    :rules="[v => !!v || 'Amount is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 v-if="cboIncomeCurrencyCode.length > 0 && cboIncomeCurrencyCode !== def.currency.currencyCode">
                  <v-text-field
                    label="Rate to USD"
                    v-model="txtIncomeExchangeRateToBase"
                    :rules="[v => !!v || 'Rate to USD is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <trumbowyg id="trumbowyg" v-model="txtIncomeRemarks" :config="trumbowygConfig"></trumbowyg>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    block
                    large
                    color="primary"
                    :disabled="!frmEditIncomeValid"
                    @click="editIncome(selectedIncome.incomeId)"
                  >
                    Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="deleteIncomeDialog"
        max-width="300"
      >
        <v-card>
          <v-card-title class="subheading font-weight-bold">Are you sure to remove this incomes?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              flat="flat"
              @click="deleteIncomeDialog = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteIncome(selectedIncome.incomeId)"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="viewRemarksDialog"
        max-width="800"
      >
        <v-card class="pa-4">
          <h3 class="headline font-weight-bold">{{ incomeToView.name }}</h3>
          <div class="mt-3" v-html="incomeToView.remarks"></div>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>

  </div>
</template>

<style scoped>

form >>> div.trumbowyg-box.trumbowyg-editor-visible.trumbowyg-en.trumbowyg {
  z-index: 1;
}

td, th {
  padding: 15px 15px;
}

</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.css'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.js'
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js'
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css'
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

let $ = window.$

export default {
  props: [
    'year',
    'month'
  ],
  components: {
    SideDrawer,
    Trumbowyg,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['fontsize'],
          ['foreColor', 'backColor'],
          ['superscript', 'subscript'],
          ['link'],
          ['insertImage'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['table'],
          ['removeformat'],
          ['upload'],
          ['fullscreen']
        ],
        plugins: {
          upload: {
            serverPath: process.env.VUE_APP_API_ROOT + '/v1/costing/income/wysiwyg/image',
            fileFieldName: 'image',
            headers: {
              'Authorization': axios.defaults.headers.common['Authorization'],
              'X-API-KEY': axios.defaults.headers.common['X-API-KEY']
            },
            urlPropertyName: 'url'
          },
          resizimg: {
            minSize: 64
          }
        }
      },
      accessCreateIncome: false,
      accessReadIncome: false,
      accessUpdateIncome: false,
      accessDeleteIncome: false,
      cboYear: '',
      cboMonth: '',
      years: [],
      branches: [],
      currencies: [],
      currencyCode: this.$store.getters.getDef.currency.currencyCode,
      currencySign: this.$store.getters.getDef.currency.sign,
      currencyDecimals: this.$store.getters.getDef.currency.decimals,
      currencyDecimalSign: this.$store.getters.getDef.currency.decimalSign,
      exchangeRateToBase: this.$store.getters.getDef.currency.exchangeRateToBase,
      frmLoadIncomesValid: false,
      addIncomeDialog: false,
      frmAddIncomeValid: false,
      txtIncomeName: '',
      cboIncomeBranchId: '',
      cboIncomeCurrencyCode: '',
      txtIncomeExchangeRateToBase: 1,
      txtIncomeAmount: '',
      txtIncomeRemarks: '',
      selectedIncome: {},
      editIncomeDialog: false,
      frmEditIncomeValid: false,
      deleteIncomeDialog: false,
      viewRemarksDialog: false,
      incomeToView: '',
      incomes: [],
      totalIncomesInBase: 0
    }
  },
  computed: {
  },
  mounted () {
    this.openDrawerForDesktop()
    this.years = this.generateYearsToCurrentYear(2020)
    this.getCurrencies()
    this.getBranches()
    if (typeof this.year !== 'undefined' && this.year > 0) {
      if (typeof this.month !== 'undefined' && this.month > 0) {
        this.getIncomes(this.year, this.month)
      }
    }

    // determine income access
    for (let i = 0; i < this.profile.permissions.length; i++) {
      if (this.profile.permissions[i].permissionId === 'PEM-EXPENSES' && this.profile.permissions[i].isCreate === '1') {
        this.accessCreateIncome = true
      }
      if (this.profile.permissions[i].permissionId === 'PEM-EXPENSES' && this.profile.permissions[i].isRead === '1') {
        this.accessReadIncome = true
      }
      if (this.profile.permissions[i].permissionId === 'PEM-EXPENSES' && this.profile.permissions[i].isUpdate === '1') {
        this.accessUpdateIncome = true
      }
      if (this.profile.permissions[i].permissionId === 'PEM-EXPENSES' && this.profile.permissions[i].isDelete === '1') {
        this.accessDeleteIncome = true
      }
    }

    var _this = this
    $('#trumbowyg')
      .trumbowyg() // Build Trumbowyg on the #editor element
      .on('tbwopenfullscreen', function () { _this.drawer = false; _this.isTrumbowygFullscreen = true })
      .on('tbwclosefullscreen', function () { _this.isTrumbowygFullscreen = false; _this.drawer = true })
  },

  methods: {
    showRemarks: function (income) {
      this.incomeToView = income
      this.viewRemarksDialog = true
    },
    showAddIncomeDialog: function () {
      this.txtIncomeName = ''
      this.cboIncomeBranchId = ''
      this.cboIncomeCurrencyCode = ''
      this.txtIncomeExchangeRateToBase = 1
      this.txtIncomeAmount = ''
      this.txtIncomeRemarks = ''
      this.addIncomeDialog = true
    },
    showDeleteIncomeDialog: function (income) {
      this.selectedIncome = income
      this.deleteIncomeDialog = true
    },
    showEditIncomeDialog: function (income) {
      this.selectedIncome = income
      this.cboIncomeBranchId = income.branchId
      this.txtIncomeName = income.name
      this.cboIncomeCurrencyCode = income.currencyCode
      this.txtIncomeExchangeRateToBase = income.exchangeRateToBase
      this.txtIncomeAmount = income.amount
      this.txtIncomeRemarks = income.remarks
      this.editIncomeDialog = true
    },
    addIncome () {
      var _this = this
      if (_this.$refs.frmAddIncome.validate()) {
        _this.loading = true
        var data = {
          year: _this.year,
          month: _this.month,
          name: _this.txtIncomeName,
          branchId: _this.cboIncomeBranchId,
          currencyCode: _this.cboIncomeCurrencyCode,
          exchangeRateToBase: _this.txtIncomeExchangeRateToBase,
          amount: _this.txtIncomeAmount,
          remarks: _this.txtIncomeRemarks
        }

        axios.post(process.env.VUE_APP_API_ROOT + '/v1/costing/income', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.loading = false
              _this.getIncomes(_this.year, _this.month)
              _this.addIncomeDialog = false
            } else {
              _this.loading = false
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                _this.$store.dispatch('AUTH_LOGOUT')
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    editIncome (incomeId) {
      var _this = this
      if (_this.$refs.frmEditIncome.validate()) {
        _this.loading = true
        var data = {
          name: _this.txtIncomeName,
          branchId: _this.cboIncomeBranchId,
          currencyCode: _this.cboIncomeCurrencyCode,
          exchangeRateToBase: _this.txtIncomeExchangeRateToBase,
          amount: _this.txtIncomeAmount,
          remarks: _this.txtIncomeRemarks
        }

        axios.put(process.env.VUE_APP_API_ROOT + '/v1/costing/income/' + incomeId, data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.loading = false
              _this.getIncomes(_this.year, _this.month)
              _this.editIncomeDialog = false
            } else {
              _this.loading = false
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                _this.$store.dispatch('AUTH_LOGOUT')
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    deleteIncome (incomeId) {
      var _this = this
      _this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/costing/income/' + incomeId)
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.getIncomes(_this.year, _this.month)
            _this.deleteIncomeDialog = false
          } else {
            window.alert('unable to remove incomes: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              _this.$store.dispatch('AUTH_LOGOUT')
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getBranches: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/branches')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            let temp = [
              {
                branchId: '',
                name: ''
              }
            ]
            _this.branches = temp.concat(resp.data.data)
          } else {
            console.log('unable to load branches: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getCurrencies: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            for (var i in resp.data.data) {
              if (resp.data.data[i].currencyCode === _this.currencyCode) {
                resp.data.data[i].exchangeRateToBase = _this.exchangeRateToBase
              }
            }
            _this.currencies = resp.data.data
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getRateToBase: function (currencyCode) {
      for (var i in this.currencies) {
        if (this.currencies[i].currencyCode === currencyCode) {
          return this.currencies[i].exchangeRateToBase
        }
      }
      return 0
    },
    getIncomes: function (year, month) {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/costing/incomes/' + year + '/' + month)
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.incomes = resp.data.data
            _this.cboYear = parseInt(year)
            _this.cboMonth = parseInt(month)
            let totalIncomes = 0
            for (let i in resp.data.data) {
              totalIncomes += resp.data.data[i].totalAmountInBase
            }
            _this.totalIncomesInBase = totalIncomes
          } else {
            window.alert('Invalid year / month')
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
          }
          _this.loading = false
        })
    }
  }
}
</script>
